import React from 'react';
import { SEO } from '../components/SEO';
import { PersonalHero } from '../components/PersonalHero';
import { StatsBar } from '../components/StatsBar';
import { StorySection } from '../components/StorySection';
import { JourneyTimeline } from '../components/JourneyTimeline';
import { UniqueValue } from '../components/UniqueValue';
import { ResultsSection } from '../components/ResultsSection';
import { PhilosophySection } from '../components/PhilosophySection';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <SEO title="Justus Kraft - CRM Expert | Sales Automation Specialist" description="Started my first business at 16. Now at 23, I help companies double their sales through intelligent CRM systems. 110+ happy clients, GDPR compliant, $7M+ in additional revenue generated." keywords="CRM expert, sales automation, CRM consulting, Justus Kraft, CRM Kraft, B2B sales, B2C sales, CRM systems, sales optimization, revenue growth, lead management" data-id="element-425" />
      <main data-id="element-426">
        <PersonalHero data-id="element-427" />
        <StatsBar data-id="element-428" />
        <StorySection data-id="element-429" />
        <JourneyTimeline data-id="element-430" />
        <UniqueValue data-id="element-431" />
        <ResultsSection data-id="element-432" />
        <PhilosophySection data-id="element-433" />
        <FinalCTA data-id="element-434" />
      </main>
    </>;
}